import React from 'react'
import Icon from './Icon'
import Button from './ui/Button'
import './FilterBar.css'

/**
 * Блок фильтров в едином стиле: опциональный toggle (Фильтр + счётчик), контент с полями, кнопка сброса.
 * Дети — обёртки .filter-group с полями (Input/Select из каталога).
 *
 * @param {{
 *   expandable?: boolean,
 *   expanded?: boolean,
 *   onToggle?: () => void,
 *   filterCount?: number,
 *   onClear?: () => void,
 *   clearLabel?: string,
 *   isMobile?: boolean,
 *   children: React.ReactNode,
 *   className?: string
 * }} props
 */
function FilterBar ({
  expandable = false,
  expanded = true,
  onToggle,
  filterCount = 0,
  onClear,
  clearLabel = 'Сбросить фильтры',
  isMobile = false,
  children,
  className = ''
}) {
  const contentClass = isMobile ? 'filter-bar__content filter-bar__content--mobile' : 'filter-bar__content filter-bar__content--desktop'
  const contentExpandedClass = expandable && expanded ? ' filter-bar__content--expanded' : ''
  const rootClass = expandable ? 'filter-bar filter-bar--expandable' : 'filter-bar'
  const legacyContentClass = expandable ? (isMobile ? ' filters-main-mobile' : ' filters-main') : ''

  return (
    <div className={`${rootClass} ${className}`.trim()}>
      {expandable && (
        <Button
          type="button"
          variant="secondary"
          className="filter-bar__toggle filters-toggle-btn"
          onClick={onToggle}
        >
          <span className="filter-bar__toggle-inner">
            <Icon name="settings" size={16} />
            Фильтр
          </span>
          {filterCount > 0 && (
            <span className="filter-count">({filterCount})</span>
          )}
          <span className="filter-bar__chevron" aria-hidden>
            <Icon name={expanded ? 'chevronDown' : 'chevronRight'} size={14} />
          </span>
        </Button>
      )}
      <div className={`${contentClass}${contentExpandedClass}${legacyContentClass}`}>
        <div className="filter-bar__fields">
          {children}
        </div>
        {onClear && filterCount > 0 && (
          <Button
            type="button"
            variant="ghost"
            className={`filter-bar__clear ${isMobile ? 'clear-filters-btn' : 'clear-filters-btn-desktop'}`}
            onClick={onClear}
          >
            {clearLabel}
          </Button>
        )}
      </div>
    </div>
  )
}

export default FilterBar
